import { fetchWithAuth } from './fetchWithAuth';

export const fetchGroupList = async () => {
  return fetchWithAuth(`/code/groups`);
};

export const fetchCodeList = async (group_cd) => {
  return fetchWithAuth(`/code/groups/${group_cd}/codes`);
};

export const createGroup = async (form) => {
  return fetchWithAuth(`/code/groups`, { method: 'POST', body: JSON.stringify(form) });
};

export const updateGroup = async (group_cd, form) => {
  return fetchWithAuth(`/code/groups/${group_cd}`, { method: 'PUT', body: JSON.stringify(form) });
};

export const deleteGroup = async (group_cd) => {
  return fetchWithAuth(`/code/groups/${group_cd}`, { method: 'DELETE' });
};

export const createCode = async (group_cd, form) => {
  return fetchWithAuth(`/code/groups/${group_cd}/codes`, { method: 'POST', body: JSON.stringify(form) });
};

export const updateCode = async (group_cd, code, form) => {
  return fetchWithAuth(`/code/groups/${group_cd}/codes/${code}`, { method: 'PUT', body: JSON.stringify(form) });
};

export const deleteCode = async (group_cd, code) => {
  return fetchWithAuth(`/code/groups/${group_cd}/codes/${code}`, { method: 'DELETE' });
};

// localStorage에서 공통코드 조회 (로그인 후 캐시된 데이터) — fetch 아님, 변환 대상 아님
export const getCodeList = (group_cd) => {
  try {
    const data = JSON.parse(localStorage.getItem(`code_${group_cd}`) || '[]');
    return data.filter(c => c.use_yn === 'Y');
  } catch {
    return [];
  }
};

export const getCodeNm = (group_cd, code) => {
  const list = getCodeList(group_cd);
  return list.find(c => c.code === code)?.code_nm || code;
};